import Heading from './Heading';
import Paragraph from './Paragraph';
import Subheading from './Subheading';
import Label from './Label';
export { Heading, Paragraph, Subheading, Label };
